module.exports = __webpack_public_path__ + "media/images/keeplist_ic-outline-dee41f02ed8952be590dad81d661cd75.svg";